import axios from "axios";

export const getDocumentType = async (data) => {
    try {
        let res = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/rental/document_mapping`,
            data
        });
        return res;
    } catch (error) {
        return error;
    }
}

export const getDocumentsByProject = async (data) => {
    try {
        let res = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/rental/rental_document`,
            data
        });
        return res;
    }
    catch (error) {
        return error;
    }
}

export const getDocumentFile = async ({ base_url, file_name }) => {
    try {
        let res = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/rental/get-document-file`,
            data: { base_url, file_name, method: 'GET' },
        });
        return res;
    }
    catch (error) {
        return error;
    }
}
